<template>
  <v-row class="ma-0 pa-0">
    <v-col cols="12" class="pa-0">
      <v-sheet class="mb-2">
        <v-skeleton-loader type="article" v-if="loading"></v-skeleton-loader>
        <v-col v-else class="px-6 py-4">
          <v-row class="ma-0">
            <h2>Medical contact</h2>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="9" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="4" lg="2" class="pa-0">
                  <div class="text-section-title">Doctor</div>
                </v-col>
                <v-col cols="12" md="8" lg="6" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.medical.doctor"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="9" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="4" lg="2" class="pa-0">
                  <div class="text-section-title">Address line 1</div>
                </v-col>
                <v-col cols="12" md="8" lg="6" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.medical.address.line1"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="9" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="4" lg="2" class="pa-0">
                  <div class="text-section-title">Address line 2</div>
                </v-col>
                <v-col cols="12" md="8" lg="6" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.medical.address.line2"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="6" lg="3" class="pa-0">
                  <span class="text-section-title pr-2">City/Town</span>
                </v-col>
                <v-col cols="12" md="6" lg="6" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.medical.address.city"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col
                  cols="12"
                  md="4"
                  lg="3"
                  class="pa-0"
                  :align="$vuetify.breakpoint.mdAndUp ? 'end' : 'start'"
                >
                  <span class="text-section-title pr-2">Postcode</span>
                </v-col>
                <v-col cols="12" md="6" lg="4" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.medical.address.postcode"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="9" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="4" lg="2" class="pa-0">
                  <div class="text-section-title">Contact number</div>
                </v-col>
                <v-col cols="12" md="8" lg="3" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.medical.contactNumber"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-sheet>
      <v-sheet class="mb-2">
        <v-skeleton-loader type="article" v-if="loading" />
        <v-col v-else class="px-6 py-4">
          <v-row class="ma-0" align="center">
            <h2>Medical conditions</h2>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              outlined
              tile
              class="button"
              @click="conditionsPopupVisible = true"
              >Edit</v-btn
            >
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="9" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="4" lg="2" class="pa-0">
                  <div class="text-section-title">Condition</div>
                </v-col>
                <v-col cols="12" md="8" lg="10" class="pa-0">
                  <v-chip-group
                    v-if="restrictedProfileData.medical.conditions.length > 0"
                  >
                    <template
                      v-for="cond in restrictedProfileData.medical.conditions"
                    >
                      <v-chip
                        color="background"
                        close
                        @click:close="removeCondition(cond)"
                        :key="cond"
                        >{{ cond }}</v-chip
                      >
                    </template>
                  </v-chip-group>
                  <p v-else class="pt-4 pl-2">None specified</p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="9" class="pa-0">
              <v-row class="ma-0">
                <v-col cols="12" md="4" lg="2" class="pa-0">
                  <div class="text-section-title">Condition details</div>
                </v-col>
                <v-col cols="12" md="8" lg="10" class="pa-0">
                  <v-textarea
                    filled
                    class="px-2"
                    v-model="restrictedProfileData.medical.conditionDetails"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-sheet>
    </v-col>
    <v-dialog
      v-model="conditionsPopupVisible"
      max-width="600px"
      persistent
      scrollable
    >
      <common-editing-popup
        title="Conditions"
        @close="conditionsPopupVisible = false"
        saveBtnTitle="Done"
        :canSubmit="true"
        @submit="conditionsPopupVisible = false"
      >
        <template v-slot:default>
          <v-text-field
            v-model="conditionsSearch"
            clearable
            filled
            prepend-inner-icon="mdi-magnify"
            placeholder="Search"
            class="mt-2"
          >
          </v-text-field>
          <template v-for="cond in searchedConditions">
            <v-checkbox
              v-model="restrictedProfileData.medical.conditions"
              :key="cond"
              :label="cond"
              :value="cond"
            ></v-checkbox>
          </template>
        </template>
      </common-editing-popup>
    </v-dialog>
  </v-row>
</template>

<script>
import CommonEditingPopup from '@/components/CommonEditingPopup.vue'
import availableConditions from './conditions.json'
export default {
  props: ['id', 'profileData', 'restrictedProfileData'],
  components: {
    CommonEditingPopup,
  },
  data: () => ({
    conditionsPopupVisible: false,
    conditionsSearch: '',
  }),
  computed: {
    loading() {
      return !this.profileData || !this.restrictedProfileData
    },
    searchedConditions() {
      if ((this.conditionsSearch?.trim().length ?? 0) == 0) {
        return availableConditions
      }

      const pattern = new RegExp('^.*' + this.conditionsSearch + '.*$', 'i')

      return availableConditions.filter((c) => pattern.test(c))
    },
  },
  methods: {
    removeCondition(condition) {
      this.restrictedProfileData.medical.conditions = this.restrictedProfileData.medical.conditions.filter(
        (c) => c !== condition
      )
    },
  },
}
</script>

<style lang="sass" scoped>
.v-chip-group
  padding: 0 8px
</style>